import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, signal } from '@angular/core';
import { NgIf } from '@angular/common';
import { SelectMenuComponent, SelectMode } from '../../../shared/components/select-menu/select-menu.component';
import { SelectBrandItem } from '../../../services/dashboard.service';
import { FormControl } from '@angular/forms';
import { RemoveIconComponent } from '../../../shared/components/icons/remove-icon/remove-icon.component';

@Component({
  selector: 'app-brand-chip',
  imports: [NgIf, SelectMenuComponent, RemoveIconComponent],
  templateUrl: './brand-chip.component.html',
  styleUrl: './brand-chip.component.scss'
})
export class BrandChipComponent implements OnInit, OnChanges {
  @Input({required: true}) label?: string
  @Input({required: true}) key?: string;
  @Input({required: true}) color?: string;
  @Input() icon?: string;
  @Input() group?: { label: string; order: number };
  @Input() brandsOptions?: SelectBrandItem[] = [];
  @Input() disabled = false;
  @Input() displayRemoveButton = true;
  @Input() displayBrandColor = true;
  @Input() isCompetitor = false;
  @Input() isTrialUser = false;
  @Output() brandChanged = new EventEmitter<string>();
  @Output() brandRemoved = new EventEmitter<string>();

  protected isExpanded = false;
  protected isPanelOpen = signal(this.isExpanded);
  protected control: FormControl<string|null> = new FormControl<string|null>(this.key ?? null);
  protected readonly SelectMode = SelectMode;

  protected _brandsOptions: SelectBrandItem[] = [];

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.updateBrandsOptions();
  }

  ngOnChanges(): void {
    this.updateBrandsOptions();
  }

  updateBrandsOptions(): void {
    const options = this.brandsOptions ?? [];
    if (this.isCompetitor) {
      const brand = {
        label: this.label || '', 
        key: this.key || '',
        icon: this.icon,
        color: this.color,
        group: this.group
      };
      this._brandsOptions = [brand, ...options];
    } else {
      this._brandsOptions = options;
    }
    this.control.setValue(this.key ?? null);
  }

  toggleExpanded(): void {
    if (this.disabled) return;
    this.isExpanded = !this.isExpanded;
    this.isPanelOpen.set(this.isExpanded);
  }

  onBrandChanged(brandKey?: string | null): void {
    if (this.disabled || !brandKey) return;
    this.brandChanged.emit(brandKey);
    this.control.setValue(null);
    this.isExpanded = false;
    this.isPanelOpen.set(this.isExpanded);
  }

  onBrandRemove(event: MouseEvent): void {
    if (this.disabled) return;
    event.stopPropagation();
    this.isExpanded = false;
    this.isPanelOpen.set(this.isExpanded);
    this.brandRemoved.emit(this.key);
    this.control.setValue(null);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (this.disabled) return;
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.isExpanded = false;
      this.isPanelOpen.set(this.isExpanded);
    }
  }

  onIconError(event: Event): void {
    (event.target as HTMLImageElement).src = 'images/no-logo.png';
  }
}